import React, {useCallback, useEffect, useRef} from "react";
import {
    Chip,
    ButtonGroup,
    Button,
    Select,
    SelectItem,
    Divider,
    Card,
    CardHeader,
    CardBody,
    CheckboxGroup,
    Checkbox,
    Autocomplete,
    AutocompleteItem, Tooltip, Input, TableHeader, TableColumn, TableBody, TableRow, TableCell, Table
} from "@nextui-org/react";
import {FaEdit, FaTrash, FaEye, FaPlusCircle, FaPlus, FaMinus, FaSave, FaList} from 'react-icons/fa'
import {getMachines, getRepositors, getStockbyMachine, getUnassignedStock, SaveStock} from "../API";
import {useNavigate} from "react-router-dom";
import {toast, Toaster} from "sonner";

// tailwindcss: grid-cols-1 grid-cols-2 grid-cols-3
const statusColorMap = {
    'EM': ["danger", "En maquina"],
    'VE': ["danger", "Vendido"],
    'DP': ["secondary", "En deposito"],
    'RP': ["secondary", "Con repositor"],
    'PE': ["warning", "Pendiente"],
    'NA': ["success", "Sin asignar"],
    'DA': ["success", "Dañado"],
};

export default function StockAssign() {
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState([]);
    const [stock, setStock] = React.useState([]);
    const [stockItem, setStockItem] = React.useState([]);
    const [listNumber, setlistNumber] = React.useState([]);
    const navigate = useNavigate();
    const [isLoading, setisLoading] = React.useState(false);
    const [data, setData] = React.useState([]);
    const [dataList, setDataList] = React.useState([]);
    const [indexSelected, setIndexSelected] = React.useState(0);

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        const s = await getUnassignedStock({'status': 'DP', 'iduser': 0});
        const u = await getRepositors();
        setUsers(u);
        setStock(s);
    }

    function OnSelectStock(index) {
        setIndexSelected(index);

        if (index === null) {
            setStockItem([]);
            setlistNumber([])
            setData([])
            return;
        }

        const s = stock[index];
        if(dataList.filter(item => item.idproduct === s.idproduct).length > 0){
            toast.error("El producto ya esta seleccionado");
            return;
        }

        let n = [];
        for (let i = 0; i < s.stock.length; n.push(i + 1), i++) ;
        setlistNumber(n);
        setStockItem(s);
        const item = {
            idproduct: s.idproduct,
            name: s.name,
            amount: 1
        }
        setData(item);
    }

    async function OnSave(e) {
        e.preventDefault();
        setisLoading(true);

        const list = [];


        dataList.forEach(item =>{

            const index = stock.findIndex(s => s.idproduct === item.idproduct);

            if(index !== -1)
            {
                for(let i = 0; i < parseInt(item.amount); i++){
                    const f = {
                        idstock: stock[index].stock[i].idstock,
                        iduser: user.iduser,
                        status: 'RP'
                    }

                    list.push(f);
                }
            }



        })

        const item = {
            "positions": list
        }

        const data = await SaveStock(item);
        navigate("/dashboard/stock-list");
        setisLoading(false);
    }

    function OnSelectAmount(e) {
        setData(prev => ({...prev, amount: e.target.value ? e.target.value : 1}));
    }

    function AddingRow(e) {
        if(data.length <= 0) return;

        setDataList(prev => [...prev, data])
        setData([])
        setStockItem([])
        setlistNumber([])
        setIndexSelected(null);
    }

    function RemoveProduct(item) {
        const remove = dataList.filter(s => s.idproduct !== item.idproduct);
        setDataList(remove);
    }

    function OnSelectRepositor(index) {
        const u = users[index];
        setUser(u);
    }

    return (
        <>

            <Toaster richColors/>
            <h1 className="text-2xl pb-3">Asignaciones a repositor</h1>
            <Divider orientation="horizontal"/>
            <Autocomplete
                label="Seleccionar repositor"
                className="p-5"
                onSelectionChange={OnSelectRepositor}
                isClearable={false}
            >
                {
                    users.map((item, index) => (
                        <AutocompleteItem key={index} value={item.iduser} textValue={`${item.username} - ${item.surname}, ${item.firstname}`}>
                            {item.username} - {item.surname}, {item.firstname}
                        </AutocompleteItem>
                    ))
                }
            </Autocomplete>
            <Divider orientation="horizontal"/>
            <div className="container">

                <div className="flex w-full flex-shrink p-2">
                    <h2 className="text-xl text-warning">Stock</h2>
                    <div className="flex w-full flex-wrap gap-4 p-5">
                    </div>
                    <Tooltip content="Guardar">
                        <Button color="success" variant="ghost" isLoading={isLoading} isIconOnly
                                isDisabled={dataList.length === 0} onClick={OnSave}><FaSave/></Button>
                    </Tooltip>
                </div>
                <Divider orientation="horizontal"/>
                <div className="flex w-full flex-wrap md:flex-nowrap mb-6 md:mb-0 gap-4 p-3 items-center">
                    <Autocomplete
                        label="Seleccionar producto del stock"
                        className="w-full max-w-xs"
                        onSelectionChange={OnSelectStock}
                        selectedKey={indexSelected}
                        isDisabled={user.length === 0}
                        isClearable={false}
                    >
                        {
                            stock.map((item, index) => (
                                <AutocompleteItem key={index} value={item.idproduct}>
                                    {item.name}
                                </AutocompleteItem>
                            ))
                        }
                    </Autocomplete>
                    <Select
                        label="Cantidad"
                        className="max-w-32 max-h-15"
                        isDisabled={!listNumber || listNumber.length === 0}
                        onChange={OnSelectAmount}
                    >
                        {
                            listNumber.length > 0 ? (
                                listNumber.map((item) => (
                                    <SelectItem key={item} textValue={item}>{item}</SelectItem>
                                ))) : null

                        }
                    </Select>
                    <Tooltip content="Añadir producto">
                        <Button isIconOnly color="primary" onClick={AddingRow}  isDisabled={user.length === 0}><FaPlus/></Button>
                    </Tooltip>
                </div>

                <Divider orientation="horizontal"/>
                <Table aria-label="Productos">
                    <TableHeader>
                        <TableColumn key={"Producto"}>PRODUCTO</TableColumn>
                        <TableColumn key={"Cantidad"}>CANTIDAD</TableColumn>
                        <TableColumn key={"Acciones"}>ACCIONES</TableColumn>
                    </TableHeader>
                    <TableBody>
                        {
                            dataList.length > 0 ? (
                                dataList.map((item, index) => (
                                    <TableRow key={item.idproduct}>
                                        <TableCell>{item.name}</TableCell>
                                        <TableCell>{item.amount}</TableCell>
                                        <TableCell><Button color="transparent" className="text-danger" isIconOnly onClick={(e)=>RemoveProduct(item)}><FaTrash/></Button></TableCell>
                                    </TableRow>
                                ))
                            ):null
                        }

                    </TableBody>
                </Table>
            </div>

        </>

    );
}
